import React from 'react';
import {useSingleTheme} from '../../components/hooks/hooks-mongoDB/useSingleTheme';
import {useArticles} from '../../components/hooks/hooks-mongoDB/useArticles';
import {useParagraphs} from '../../components/hooks/hooks-mongoDB/useParagraphs';
import ThemesScreen from '../../components/modules/pannelli/ThemesScreen';
import {ABWHeadLinks} from '../../components/modules/pannelli/HeadLink';
import '../../components/modules/pannelli/themesScreen.scss';

function ClassDenom() {
    const {theme} = useSingleTheme('abruzzowines');
    const abruzzowines_Theme = theme;
    const {articles} = useArticles('abruzzowines');
    let article = articles.slice(1, 2) || [];
    const articles_Denom = article[0]
    const {paragraphs} = useParagraphs('abruzzowines_2');

    return (
        <section>
            {theme && <ABWHeadLinks title={abruzzowines_Theme.tema_titolo} /> }
            <ThemesScreen theme={abruzzowines_Theme} article={articles_Denom} paragraphs={paragraphs}/> 
        </section>
    )
}
export default ClassDenom;
